/**
 * Adapter boundary: ISO 'YYYY-MM-DD' ↔ CalendarDate.
 *
 * CalendarDate types from @internationalized/date must NOT leak past this module.
 * All consumer code works exclusively with ISO string dates.
 */
import { CalendarDate, parseDate } from '@internationalized/date';

/**
 * Parses an ISO 'YYYY-MM-DD' string to a CalendarDate.
 * Throws if the string is not a valid ISO date.
 */
export function parseIsoToCalendarDate(isoDate: string): CalendarDate {
  return parseDate(isoDate);
}

/**
 * Converts a CalendarDate to an ISO 'YYYY-MM-DD' string.
 */
export function calendarDateToIso(calendarDate: CalendarDate): string {
  return calendarDate.toString();
}
